import { render, staticRenderFns } from "./editTelephone.vue?vue&type=template&id=f6464e84&scoped=true&"
import script from "./editTelephone.vue?vue&type=script&lang=js&"
export * from "./editTelephone.vue?vue&type=script&lang=js&"
import style0 from "./editTelephone.vue?vue&type=style&index=0&id=f6464e84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6464e84",
  null
  
)

export default component.exports